import React,{ Component } from "react";
import '../assets/css/RadioDesign.css'
import '../assets/css/Loading.css'
import Chapcha from '../Helper/Chapcha.js'

import ProgressBar from '../components/ProgressBar.js'
import convert from '../Helper/NumberToWord'
import Loading from '../Helper/Loading.js'
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'
import CheckVarizId from '../Helper/CheckVarizId.js'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Input,
  Modal,
  Form
} from "reactstrap";
var viparam='';
class Payment extends Component {

  constructor(props) {
    super(props);
    this.state = {

      nextdisable: false,
      PersianWord: '',
      AmountString: '',
      OrgLoading: true,
      PayLoading: true,
      TaxType: [],
      UserOrgInfo: {},
      TipsLoading:true,
      TipsPage:[],
      BankList:[],
      SelectBank:"",
      SubmitBtnClick:false,
      NameValidate:{
        Valid: false,
        ClassName: "",
        Message: ""
      },
      PhoneValidate:{
        Valid: false,
        ClassName: "",
        Message: ""
      },
      AmountValidate:{
        Valid: false,
        ClassName: "",
        Message: ""
      },
      VarizValidate:{
        Valid: false,
        ClassName: "",
        Message: ""
      },
      TaxValidate:{
        Valid: false,
        ClassName: "",
        Message: ""
      },
      VarizDisable:true,
      AmountDisable:false,
      BankEmpty:false,
      ModalOpen:false,
      GoToBankLoading:false,
      current:1,
      SubmitValues:{
        BankInfoId: '',
        TaxTypeId: '',
        VarizId: '',
        Amount: '',
        PayerName: '',
        PayerMobile: '',
        PayerEmail: '',
        Description: '',
        RefrenceType: 0
      },
      captcha:'',
      captchaEnter:'',
      captchaRefresh:false,
      MellatFormSubmit:{
        RefId: '',
        Url: ''
      },
      PaymentRequest:{
        IsLoading: true,
        PaymentReceipt: {}
      }
    }
  }

  UNSAFE_componentWillMount(){
    const { am,vi }=this.props.match.params;
    this.SetParams(am,vi);
  }


 num2en = (str)=> {
    var persinNum = [/۰/gi, /۱/gi, /۲/gi, /۳/gi, /۴/gi, /۵/gi, /۶/gi, /۷/gi, /۸/gi, /۹/gi];
     for (var i = 0; i < 10; i++) {
       str = str.replace(persinNum[i], i);
     }
     return str;
   };

  SubmitClick = () => {
    const{BankEmpty,SubmitValues,captcha,captchaEnter,current}=this.state;
    this.setState({SubmitBtnClick:true});
    this.RefreshBtn();
    if(BankEmpty){
  Swal.fire({
    title: 'عملیات ناموفق',
    text: 'بانکی برای پرداخت وجود ندارد',
    icon: 'error',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Ok'
  });
  this.setState({SubmitBtnClick:false});
}else{
   if (captcha !== captchaEnter) {
    Swal.fire({
        title: 'اطلاعات نادرست',
        text: 'کد امنیتی را بدرستی وارد کنید',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
    });
    this.setState({SubmitBtnClick:false});
}
    else if (this.CheckAllValidate()) {
      const config = {
        method: "Post",
        url: "Payment/PaymentRequest",
        Authorization: true,
        data: SubmitValues
      }
      apiCall(config, (response) => {
      //  setSubmitBtnClick(false);
        if (response.data.Result == null) {
          Swal.fire({
            title: 'عملیات موفق',
            text: response.data.Message,
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          });
        }
        
        else {
          this.setState({
            SubmitBtnClick:false,
            ModalOpen:true,
          });
          if (current >= 3) {
            this.setState({
              nextDisable:true,
              current:4
            })
          }
          else {
            this.setState({
              current:this.state.current + 1
            })
          }
          this.setState({
            PaymentRequest:{
            IsLoading: false,
            PaymentReceipt: response.data.Result
          }
          })
        }

      }, (err) => {
        console.log(err)
        Swal.fire({
          title: 'عملیات ناموفق',
          text: err,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok'
        });
      });
    }
    else {
      this.setState({SubmitBtnClick:false});
      Swal.fire({
        title: 'عملیات ناموفق',
        text: 'مقادیر را بدرستی وارد کنید',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    }
  }
  }

 GoToBank = () => {
   const {PaymentRequest}=this.state;
   this.setState({
     GoToBankLoading:true
   })
    var dataBank = {};
    if (PaymentRequest.PaymentReceipt.BankId === "1000") {
      dataBank = {
        Resnum: PaymentRequest.PaymentReceipt.ResNum,
        Callback: window.location.origin + "/VerifyMeli"
      }
    }
    if (PaymentRequest.PaymentReceipt.BankId === "04") {
      dataBank = {
        Resnum: PaymentRequest.PaymentReceipt.ResNum,
        Callback: window.location.origin + "/VerifyMellat"
      }
    }

    //parsian 

    if (PaymentRequest.PaymentReceipt.BankId === "2000") {
      dataBank = {
        Resnum: PaymentRequest.PaymentReceipt.ResNum,
        Callback: window.location.origin + "/VerifyParsian"
      }
    }
    //
    const config = {
      method: "Post",
      url: "Payment/ConfirmPayRequest",
      Authorization: true,
      data: dataBank
    }
    apiCall(config, (response) => {
      this.setState({
        GoToBankLoading:false
      })
      if (PaymentRequest.PaymentReceipt.BankId === "1000") {
        window.location.assign(response.data.Result.RedirectUrl);
      }
      else if (PaymentRequest.PaymentReceipt.BankId === "04") {
        this.setState({
          MellatFormSubmit:{
          RefId: response.data.Result.Token,
          Url: response.data.Result.RedirectUrl
        }
        })
        document.getElementById("formMellat").submit()
      }
      else if(PaymentRequest.PaymentReceipt.BankId === "2000"){
        window.location.assign(response.data.Result.RedirectUrl);
      }
    }, (err) => {
      this.setState({
        GoToBankLoading:false
      })
      Swal.fire({
        title: 'عملیات ناموفق',
        text: err,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      });
    });
  }

 CheckAllValidate = () => {
   const {TaxValidate,VarizValidate,VarizDisable,AmountValidate,NameValidate,PhoneValidate}=this.state;
    var result = true;
    if (TaxValidate.Valid === false) {
      this.setState({
        TaxValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "نوع عوارض را انتخاب کنید"
      }
      })
      result = false;
    }
    if (!VarizDisable && (VarizValidate.Valid === false)) {
      this.setState({
        VarizValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "شناسه واریز را بدرستی وارد کنید"
      }
      })
      result = false;
    }
    if (AmountValidate.Valid === false) {
      this.setState({
        AmountValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "مبلغ را بدرستی وارد کنید"
      }
      })
      result = false;
    }
    if (PhoneValidate.Valid === false) {
      this.setState({
        PhoneValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "شماره همراه را بدرستی وارد کنید"
      }
      })
      result = false;
    }

    if (NameValidate.Valid === false) {
      this.setState({
        NameValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "نام‌و‌نام‌خانوادگی باید بیشتر از 5 حرف باشد"
      }
      })
      result = false;
    }
    return result;
  }

 ValidClassName = (input) => {
    if (input === true) {
      return "is-valid"
    }
    else return "is-invalid"
  }

   AmountChange =(input) => {
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "").replace(/^0+/, "");
    input = removeNonNumeric(this.num2en(input))
    if (!input && input === "") {
      this.setState({
        AmountValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "مبلغ را وارد کنید"
      }
      })
    }
    else if (input < 1) {
      this.setState({
        AmountValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "مبلغ را بدرستی وارد کنید"
      }
      })
    }
    else {
      const {SubmitValues}=this.state;
      SubmitValues.Amount= input;
      this.setState({
        PersianWord:convert(input),
        AmountValidate:{
        Valid: true,
        ClassName: this.ValidClassName(true),
        Message: ""
      },
      SubmitValues:SubmitValues,
      AmountString:addCommas(input)
      })
    }
  };


 ChangeRadio = (input) => {
   this.setState({
     SelectBank:input.AccountNumber,
     SubmitValues:
     { ...this.state.SubmitValues,        
      BankInfoId: input.BankInfoId
     }
   })
  }
  
 PhoneChangeHandel = (target) => {
    var
      mobileReg = /(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|0|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/ig;

    if (this.num2en(target.value).match(mobileReg)) {
      this.setState({
        PhoneValidate:
        {
        Valid: true,
        ClassName: this.ValidClassName(true),
        Message: ""
      },
      SubmitValues:
      { 
        ...this.state.SubmitValues,
         PayerMobile: this.num2en(target.value)
         }
      })
    }
    else {
      this.setState({
        PhoneValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "شماره همراه را بدرستی وارد کنید"
      }
      })
    }
  }

 NameChangeHandel = (target) => {
    if (target.validity.valid) {
      this.setState({
        NameValidate:
          {
        Valid: true,
        ClassName: this.ValidClassName(true),
        Message: ""
      },
      SubmitValues:{ 
        ...this.state.SubmitValues,
         PayerName: target.value
         }
      })
    }
    else {
      this.setState({
        NameValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "نام‌و‌نام‌خانوادگی باید بیشتر از 5 حرف باشد"
      }
      })
    }
  }

 VarizChangeHandel =(input) => {
    input=this.num2en(input);
    if (!input && input.trim() === "") {
      this.setState({
        VarizValidate:
        {
          Valid: false,
          ClassName: this.ValidClassName(false),
          Message: "شناسه واریز را وارد کنید"
        }
      })
    }
    else if (input.length < 8) {
      this.setState({
        VarizValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: " طول شناسه واریز نباید کمتر از 8 رقم باشد"
      }
      })
    }
    else if (CheckVarizId(input)) {
      this.setState({
       VarizValidate: {
        Valid: true,
        ClassName: this.ValidClassName(true),
        Message: ""
      },
      SubmitValues:{ 
        ...this.state.SubmitValues,
         VarizId: input 
        }
      })
    }
    else {
      this.setState({
        VarizValidate:
        {
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "شناسه واریز را بدرستی وارد کنید"
      }
      })
    }
  };

 TaxChangeHandel = (target) => {
   const{TaxType,SubmitValues}=this.state;
    if (target.validity.valid) {  
      var Tax = TaxType.find(element => element.ID === target.value);
      this.setState({
        TaxValidate:{
          Valid: true,
          ClassName: this.ValidClassName(true),
          Message: ""
        },
        SubmitValues:{ 
          ...SubmitValues,
           TaxTypeId: Tax.ID 
          }
      })
      if (Tax.VarizIdRequired) {
        this.setState({VarizDisable:false})
      }
      else {
        this.setState({VarizDisable:true})
      }
    }
    else {
      this.setState({
        TaxValidate:{
        Valid: false,
        ClassName: this.ValidClassName(false),
        Message: "نوع عوارض را انتخاب کنید"
        }
      })
    }
  }

   DescriptionChangeHandel = (target) => {
    this.setState({
      SubmitValues:{...this.state.SubmitValues, Description: target.value }
    })
  }

 ModalCloseHandel = () => {
   const{ PaymentRequest }=this.state;
   this.setState({
    ModalOpen:false,
    current:1,
    PaymentRequest:{
      ...PaymentRequest,
      IsLoading: true
    }
   })
  }

 chapchaHandelChange = (target) => {
    this.setState({captchaEnter:target.value});
}

 RefreshBtn=()=>{
  const { captchaRefresh } = this.state
  this.setState({captchaRefresh:!captchaRefresh});
}

 result = (text) => {
  this.setState({captcha:text});
}

componentDidMount=() =>{
  this.GetUserData();
}

SetParams=(am,vi) => {
  if (am && am !== "") {
    this.setState({AmountDisable:true})
    this.AmountChange(am);
  }
  if (vi && vi !== "") {
    viparam=vi;
    this.VarizChangeHandel(vi)
  }
};

GetUserData=() => {
  try{
    const { SubmitValues } = this.state;
    const config = {
      method: "Post",
      url: "User/GetUserTaxType",
      Authorization: true,
      data: {},
    };
    const Orgconfig = {
      method: "Post",
      url: "User/GetUserOrganizationInfo",
      Authorization: true,
      data: {},
    };
    const Tipsconfig = {
      method: "Post",
      url: "User/GetUserTipsByPage",
      Authorization: true,
      data: { Page: 1 },
    };
    const Accountconfig = {
      method: "Post",
      url: "Payment/GetUserAccount",
      Authorization: true,
      data: {},
    };
    //  https://avarezonline.ir/api/Payment/PaymentRequest
    //  https://avarezonline.ir/api/Payment/GetUserAccount
    //  https://avarezonline.ir/api/Payment/ConfirmPayRequest
    //  https://avarezonline.ir/api/Payment/GetPaymentByResNum


    apiCall(
      config,
      (response) => {
        this.setState({
          PayLoading: false,
          TaxType: response.data.Result,
        });
      },
      (err) => {
        Swal.fire({
          title: "عملیات ناموفق",
          text: err,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    );

    apiCall(
      Orgconfig,
      (response) => {
        this.setState({
          OrgLoading: false,
          UserOrgInfo: response.data.Result,
        });
      },
      (err) => {
        Swal.fire({
          title: "عملیات ناموفق",
          text: err,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    );

    apiCall(
      Tipsconfig,
      (response) => {
        this.setState({
          TipsLoading: false,
          TipsPage: response.data.Result,
        });
      },
      (err) => {
        Swal.fire({
          title: "عملیات ناموفق",
          text: err,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    );

    apiCall(
      Accountconfig,
      (response) => {
        this.setState({
          BankList: response.data.Result,
        });
        if (response.data.Result.length > 0) {
          this.setState({
            SelectBank: response.data.Result[0].AccountNumber,
            SubmitValues: {
              ...SubmitValues,
              BankInfoId: response.data.Result[0].BankInfoId,
            },
          });
        } else {
          this.setState({
            BankEmpty: true,
          });
        }
      },
      (err) => {
        Swal.fire({
          title: "عملیات ناموفق",
          text: err,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
    );
  } catch (error) {
  console.log(error)
}
};


render() {
  const {MellatFormSubmit,ModalOpen,current,PayLoading,TaxValidate,TaxType,
    VarizDisable,VarizValidate,AmountValidate,AmountString,PersianWord,
    NameValidate,PhoneValidate,BankList,SelectBank,captchaRefresh,
    OrgLoading,UserOrgInfo,TipsPage,TipsLoading,PaymentRequest,nextdisable,AmountDisable
  }=this.state;


  return (
    <>
      <Form id="formMellat" name="form1" method="Post" action={MellatFormSubmit.Url}>
        <input name="RefId" type="hidden" value={MellatFormSubmit.RefId} />
      </Form>


      <Modal className="modal-lg paymodal" isOpen={ModalOpen}  >
        <div className="modal-header" style={{ boxShadow: "rgb(152 182 187) 0px 5px 18px 0px", paddingBottom: "10px" }}>    
         <strong >صورتحساب پرداخت کمک های مردمی</strong>
          <hr />
        </div>

        <div className="modal-body">
          {PaymentRequest.IsLoading ? <Loading /> :
            <Col md="12">
              <Col md="7" >
                <Row>
                  <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                    {/* <label> عنوان </label> */}
                    <strong>{PaymentRequest.PaymentReceipt.TaxType}</strong>
                  </Col>
                </Row>
                <hr style={{ marginBottom: '2px' }} />

                <Row>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p> شناسه واریز </p>
                    <strong>{PaymentRequest.PaymentReceipt.VarizId} </strong>
                  </Col>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p>  تاریخ </p>
                    <strong>{PaymentRequest.PaymentReceipt.EmissionDate}</strong>
                  </Col>
                </Row>
                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                <Row>
                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p>نام پرداخت کننده</p>
                    <strong>{PaymentRequest.PaymentReceipt.PayerName}</strong>
                  </Col>

                  <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                    <p> شماره همراه </p>
                    <strong>{PaymentRequest.PaymentReceipt.PayerMobile} </strong>
                  </Col>
                </Row>
                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                <Row>
                  <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                    <p> مبلغ پرداختی </p>
                    <strong style={{ fontSize: '28px', color: 'green' }}>{PaymentRequest.PaymentReceipt.Amount}  </strong>
                    <p>{PaymentRequest.PaymentReceipt.FaAmount}</p>
                  </Col>
                </Row>
              </Col>

              <Col md="5">
                <Card className="card-user">
                  <div>
                    <div className="author">
                      <div className="block block-one" />
                      <div className="block block-two" />
                      <div className="block block-three" />
                      <div className="block block-four" />
                        <img src={PaymentRequest.PaymentReceipt.BankLogoImg} alt="..."
                          className="avatar" />

                      <p className="description">{PaymentRequest.PaymentReceipt.BankName}</p>
                      <Row>
                        <Col className="pr-md-1" md="6" xs="6">
                          <p>شماره حساب </p>
                          <strong>{PaymentRequest.PaymentReceipt.AccountNumber} </strong>
                        </Col>
                        <Col className="pr-md-1" md="6" xs="6">
                          <p>صاحب حساب </p>
                          <strong>{PaymentRequest.PaymentReceipt.AccountOwnerName}</strong>
                        </Col>
                      </Row>
                    </div>
                  </div>

                </Card>
              </Col>
            </Col>
          }
        </div>
        <div className="modal-footer"
          style={{ boxShadow: "rgb(152 182 187) 0px 5px 18px 0px", paddingTop: "15px", paddingBottom: "15px" }}>
          <hr />
          <Col md="12">
            {PaymentRequest.IsLoading ? "" :
             (this.state.GoToBankLoading) ?
                <Button style={{ float: "right", fontSize: "14px" }} color="success mr-2" onClick={() => this.GoToBank()}> در حال انتقال به بانک  <i className="fa fa-spinner fa-spin"></i> </Button>
            :
               <Button style={{ float: "right", background: "seagreen" }} color="success mr-2" onClick={() => this.GoToBank()}>انتقال به درگاه بانک و پرداخت</Button>
            }
            <Button style={{ float: "left" }} outline color="info" onClick={() =>
              this.ModalCloseHandel()
            }>انصراف</Button>
          </Col>
        </div>
      </Modal>


      <div className="content text-right">
        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardBody>
                <ProgressBar current={current} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md="7" xs="12">
            <div className="card card-info">
              <CardHeader style={{ backgroundColor: "seagreen ", color: "white", padding: "20px" }}>
           
                <strong> پرداخت کمک های مردمی </strong>
              </CardHeader>
              <CardBody>

                {PayLoading ? <Loading /> :
                  <Col md="12">
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> پرداخت بابت :</label>
                          <Input required type="select" name="selectMulti" id="exampleSelectMulti"
                            className={TaxValidate.ClassName}
                            onChange={(event) => this.TaxChangeHandel(event.target)}
                          >
                            <option value="">انتخاب کنید</option>
                            {TaxType.map((input) =>
                              <option key={input.DisplayOrder} value={input.ID}>{input.Title}</option>
                            )}
                          </Input>
                          <span style={{ color: "red" }}>{TaxValidate.Message.length > 0 ? TaxValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> شناسه واریز :</label>
                          <Input
                            id="VarizId"
                            required={!VarizDisable}
                            disabled={VarizDisable}
                            className={"Maxpading " + VarizValidate.ClassName}
                            style={{ color: "blue", fontSize: "140%" }}
                           defaultValue={viparam}
                            placeholder="شناسه واریز (ضروری) نمونه: 97014089"
                            type="text"
                            maxLength="16"
                            minLength="8"
                            onChange={(event) => this.VarizChangeHandel(event.target.value)}
                          />
                          <span style={{ color: "red" }}>{VarizValidate.Message.length > 0 ? VarizValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> مبلغ :</label>
                          <input id="input" disabled={AmountDisable} required={!VarizDisable} className={"form-control " + AmountValidate.ClassName} placeholder="مبلغ به ریال (ضروری)" maxLength="15"
                            style={{ width: "100%", textAlign: "center", fontSize: "200%", height: "50px", color: "green" }}
                            type="text" name="any" value={AmountString} onChange={(e) => this.AmountChange(e.target.value)}
                          ></input>
                          <strong style={{ position: "absolute", left: "20px", zIndex: "99999999", border: "none", top: "40px" }} id="basic-addon1">ریال</strong>
                          <span style={{ color: "red" }}>{AmountValidate.Message.length > 0 ? AmountValidate.Message : ""}</span>
                        </FormGroup>
                        <p>{PersianWord}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>

                          <label><span style={{ color: "red" }}>*</span> نام نام خانوادگی :</label>
                          <Input
                            required
                            className={NameValidate.ClassName}
                            defaultValue=""
                            placeholder="نام و نام خانوادگی(ضروری)"
                            type="text"
                            maxLength="100"
                            minLength="5"
                            onChange={(e) => this.NameChangeHandel(e.target)}
                          />
                          <span style={{ color: "red" }}>{NameValidate.Message.length > 0 ? NameValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label><span style={{ color: "red" }}>*</span> شماره همراه :</label>
                          <Input
                            required
                            className={PhoneValidate.ClassName}
                            defaultValue=""
                            placeholder="شماره موبایل جهت ارسال کد پیگیری(ضروری)"
                            type="text"
                            maxLength="11"
                            minLength="11"
                            onChange={(e) => this.PhoneChangeHandel(e.target)}
                          />
                          <span style={{ color: "red" }}>{PhoneValidate.Message.length > 0 ? PhoneValidate.Message : ""}</span>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label> توضیحات :</label>
                          <Input
                            defaultValue=""
                            placeholder="توضیحات من برای این پرداخت"
                            type="text"
                            onChange={(event) => this.DescriptionChangeHandel(event.target)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      {BankList.map((input,key) =>
                        <Col key={key} className="pr-md-1" md={BankList.length > 1 ? "6" : "12"}>
                          <input type="radio" name="AccountNumber" id={input.AccountNumber} value={input.AccountNumber} checked={SelectBank === input.AccountNumber} onChange={() => this.ChangeRadio(input)} />
                          <label htmlFor={input.AccountNumber} className="label" aria-label="Silver">
                            <span></span>
                            {input.BankName}
                              <img src={input.BankLogoUrl} alt="Image" style={{ width: "70px", height: "60px", float: "left" }} />
                        </label>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                      <Col md="3"></Col>
                      <Col md="6" style={{textAlign:'center'}}>
                      <FormGroup>
             
                      <FormGroup style={{ marginTop: "30px" }}>
                        <Chapcha result={this.result} refresh={captchaRefresh} />
                        <li style={{marginRight:'15px',fontSize:'22px',cursor:'pointer'}} onClick={()=>this.RefreshBtn()} className="fa fa-sync"></li>
                    </FormGroup>
                    <span style={{font:'15px'}}> کد امنیتی :</span> 
                        <Input
                            style={{ fontSize: "160%", textAlign: "center" }}
                            defaultValue=""
                            placeholder=" کد امنیتی"
                            type="text"
                            maxLength="6"
                            minLength="6"
                            number="true"
                            onChange={(e) => this.chapchaHandelChange(e.target)}
                        />
                    </FormGroup>
           
                {
                     (this.state.SubmitBtnClick) ?
             
                      <button style={{ width: "100%", background: "seagreen" }} className="btn btn-success" onClick={() => this.SubmitClick()} disabled={nextdisable}> در یافت اطلاعات <i className="fa fa-spinner fa-spin" style={{marginRight:'10px'}}></i></button>
                  :
                     <button style={{ width: "100%", background: "seagreen" }} className="btn btn-success" onClick={() => this.SubmitClick()} disabled={nextdisable}>ثبت و ادامه</button>
                }
                      </Col>
                      <Col md="3"></Col>
                    </Row>
                  </Col>

                }
              </CardBody>
            </div>
          </Col>
          <Col md="5" xs="12">
            <Card className="card-info">
              <CardHeader>
           <strong>اطلاعات سازمانی</strong>
                <hr />
              </CardHeader>
              <CardBody>

                {OrgLoading ? <Loading /> :
                  <Row>
                    <Col className="pr-md-1" md="8" xs="8">
                      <FormGroup style={{ textAlign: "center" }}>
                        <p> نام سازمان </p>
                        <p style={{ fontSize: "18px", fontWeight: "bolder" }}>{UserOrgInfo.Org_Name}</p>
                      </FormGroup>
                      <hr />
                      <Row>
                        <Col className="pr-md-1" md="6" xs="6">
                          <FormGroup style={{ textAlign: "center" }}>
                            <p> استان </p>
                            <p style={{ fontSize: "16px", fontWeight: "bolder" }}>{UserOrgInfo.ProvinceName}</p>
                          </FormGroup>
                        </Col>
                        <Col className="pr-md-1" md="6" xs="6">
                          <FormGroup style={{ textAlign: "center" }}>
                            <p> شهر </p>
                            <p style={{ fontSize: "16px", fontWeight: "bolder" }}>{UserOrgInfo.CityName}</p>

                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>

                    <Col className="pr-md-1" md="4" xs="4">
                      <img style={{ width: "100%" }} src={UserOrgInfo.LogoUrl} alt="logoInfo" />
                    </Col>
                  </Row>
                }

              </CardBody>
            </Card>
{TipsPage.length>0?
            <Card className="card-info">
              <CardHeader>
            <strong >نکات</strong> 
                <hr />
              </CardHeader>
              <CardBody>

                {TipsLoading ? <Loading /> :
                  <Row>
                    <ul style={{ listStyle: "none" }}>
                      {TipsPage.map((input,key) =>
                        <li key={key}>
                          <i style={{ color: "blue" }} className="fa fa-circle"></i>&nbsp; {input.TipItemText} &nbsp;
                          {input.LinkCaption != null && input.LinkCaption !== "" ?
                            <a className="btn btn-blue btn-sm" href={input.LinkAddress} target="_blank" rel="noopener noreferrer">{input.LinkCaption}</a> : ''
                          }
                        </li>
                      )}
                    </ul>
                  </Row>
                }
              </CardBody>
            </Card>
:""}
          </Col>
        </Row>
      </div>
    </>
  );
}
}

export default Payment;
